import React from 'react';
import { cn } from '@/lib/utils';

interface TimeFilterProps {
  className?: string;
  options: readonly string[];
  value: string;
  onChange: (value: string) => void;
}

const TimeFilter = ({ options, value, onChange, className }: TimeFilterProps) => {
  return (
    <div className={cn('inline-flex overflow-hidden rounded-full bg-db-wrap border ', className)}>
      {options.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={cn(
            'min-w-[50px] px-2 py-2 title2 transition-all duration-200',
            value === item
              ? 'bg-text-blue-100 text-white shadow-sm'
              : 'text-text-grey hover:bg-white'
          )}
        >
          {item}
        </button>
      ))}
    </div>
  );
};

export default TimeFilter;
